import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取推荐商品列表
   */
  getAll() {
    return Ajax.get(`/api/productManagement/recommendedProduct`)
  },
  /**
   * 删除推荐商品
   * @param id
   */
  deleteRecommendProduct(id: string) {
    return Ajax.delete(`/api/productManagement/recommendedProduct?id=${id}`)
  },
  /**
   * 添加推荐商品
   * @param data
   */
  create(data: any[]) {
    return Ajax.post(`/api/productManagement/recommendedProduct`, {
      recommendedProducts: data
    })
  },
  /**
   * 修改推荐商品排序
   * @param id
   * @param displayOrder
   */
  updateDisplayOrder(id: string, displayOrder: number) {
    return Ajax.put(
      `/api/productManagement/recommendedProduct/displayOrder/${id}?displayOrder=${displayOrder}`)
  },
  /**
   * 批量删除商品推荐
   * @param ids
   */
  deleteProductRecommond(ids: string[]) {
    const text = ids.join("&ids=");
    return Ajax.delete(`/api/productManagement/recommendedProduct/ids?ids=${text}`);
  },
  /**
   * 导出商品推荐
   */
  exportProductRecommendFile() {
    return Ajax.get('/api/productManagement/recommendedProduct/RecoFile', { responseType: "blob" })
  }
}
